const ui = {
  state: {
    sidebarIsVisible: false,
  },
  reducers: {
    showSidebar: (state) => {
      return {
        ...state,
        sidebarIsVisible: true,
      };
    },
    hideSidebar: (state) => {
      return {
        ...state,
        sidebarIsVisible: false,
      };
    },
  },
};

export default ui;
